<button
  (click)="$event.stopPropagation()"
  [matMenuTriggerFor]="taskItemActions"
  [attr.aria-label]="'project-tasks.list.task.open-actions' | translate"
  type="button"
  class="inline-flex cursor-pointer items-center justify-center"
>
  <mat-icon
    fontIcon="more_vert"
    class="h-6! w-6! text-[24px]!"
  />
</button>

<mat-menu #taskItemActions="matMenu">
  <button
    (click)="openTimeReportDialog()"
    type="button"
    class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
  >
    <mat-icon
      fontIcon="timer"
      class="group-hover:icon-white"
    />
    <p>{{ 'time-reports-form-modal-add-time-report' | translate }}</p>
  </button>

  <proffeo-file-drop
    (filesAdded)="onFilesAdded($event)"
    mode="ngContent"
  >
    <div
      class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
    >
      <mat-icon
        fontIcon="photo_camera"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.add-file' | translate }}</p>
    </div>
  </proffeo-file-drop>

  <button
    (click)="onCopyLink()"
    type="button"
    class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
  >
    <mat-icon
      fontIcon="content_copy"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.copy-link' | translate }}</p>
  </button>

  <button
    (click)="onCopyTaskNumber()"
    type="button"
    class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
  >
    <mat-icon
      fontIcon="content_copy"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.copy-number' | translate }}</p>
  </button>

  @if (!isMobile()) {
    <button
      (click)="onCopyTask()"
      type="button"
      class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
    >
      <mat-icon
        fontIcon="folder_copy"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.copy-task' | translate }}</p>
    </button>

    <button
      (click)="openMoveTaskDialog()"
      type="button"
      class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
    >
      <mat-icon
        fontIcon="drive_file_move"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.move-task' | translate }}</p>
    </button>

    <button
      (click)="openEditFinalCostDialog()"
      type="button"
      class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
    >
      <mat-icon
        fontIcon="paid"
        class="group-hover:text-white!"
      />
      <p>{{ 'task-menu.edit-final-cost' | translate }}</p>
    </button>

    <button
      (click)="openEditContractCostDialog()"
      type="button"
      class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
    >
      <mat-icon
        fontIcon="description"
        class="group-hover:text-white!"
      />
      <p>{{ 'task-menu.edit-contract-cost' | translate }}</p>
    </button>

    <button
      (click)="onGeneratePdf()"
      type="button"
      class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
    >
      <mat-icon
        fontIcon="picture_as_pdf"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.generate-pdf' | translate }}</p>
    </button>

    @if (task().isLocked) {
      <button
        (click)="onUnlockTask()"
        type="button"
        class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
      >
        <mat-icon
          fontIcon="lock"
          class="group-hover:icon-white"
        />
        <p>{{ 'task-menu.unlock-task' | translate }}</p>
      </button>
    } @else {
      <button
        (click)="onLockTask()"
        type="button"
        class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
      >
        <mat-icon
          fontIcon="lock"
          class="group-hover:icon-white"
        />
        <p>{{ 'task-menu.lock-task' | translate }}</p>
      </button>
    }
  }

  <button
    (click)="onDeleteTask()"
    type="button"
    class="group flex w-full cursor-pointer items-center gap-2 px-2 py-3 transition-all transition-150 hover:bg-proffeo-accent hover:text-proffeo-on-action"
  >
    <mat-icon
      fontIcon="delete"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.delete-task' | translate }}</p>
  </button>
</mat-menu>
